"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRefreshCredentials = exports.validateApiCredentials = void 0;
const UserDetails_1 = require("./model/UserDetails");
const validation_1 = require("@fmtk/validation");
const AwsCredentials_1 = require("./model/AwsCredentials");
exports.validateApiCredentials = (0, validation_1.properties)({
    accessToken: (0, validation_1.text)(),
    aws: AwsCredentials_1.validateAwsCredentials,
    expiresAt: (0, validation_1.integer)(),
    refreshToken: (0, validation_1.optional)((0, validation_1.text)()),
    sub: (0, validation_1.text)(),
    user: UserDetails_1.validateUserDetails,
});
exports.validateRefreshCredentials = (0, validation_1.properties)({
    refreshToken: (0, validation_1.text)(),
});
//# sourceMappingURL=ApiCredentials.js.map